import React, { useState, useEffect, useRef } from "react";
import {
  FaComments,
  FaTimes,
  FaPaperPlane
} from "react-icons/fa";
import "./MMAChatBot.css";

const WHATSAPP_LOG_API =
  "https://api.teamohanamma.co.il/api/whatsapp-click";

const WHATSAPP_NUMBER =
  "972584772772";

const BUSINESS_PHONE =
  "0584772772";

export default function MMAChatBot() {
  const questions = [
    "שלום 👋 אני המאמן הדיגיטלי של\n🥊MMA אוחנה\nמה השם שלך ? בבקשה",
    "בן כמה אתה ?",
    "האם יש לך ניסיון בעבר באומנויות לחימה ?",
    "איזה אימון מעניין אותך ?",
    "מה המטרה שלך ?",
    "מה מספר הטלפון שלך ?"
  ];

  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [input, setInput] = useState("");
  const [options, setOptions] = useState([]);
  const [finished, setFinished] = useState(false);

  const [messages, setMessages] = useState([
    {
      from: "bot",
      text: questions[0]
    }
  ]);

  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [messages]);

  const checkAnswer = (answer, currentStep) => {
    if (currentStep === 0) {
      const hebrewName = /^[א-ת\s]{2,}$/;

      if (!hebrewName.test(answer.trim())) {
        return "נא לרשום שם מלא בעברית (לפחות 2 אותיות)";
      }

      return null;
    }

    if (currentStep === 1) {
      const age = Number(answer);

      if (
        Number.isNaN(age) ||
        age < 7 ||
        age > 65
      ) {
        return "נא לרשום גיל תקין בלבד";
      }

      return null;
    }

    if (currentStep === 2) {
      const valid = [
        "כן, יש לי ניסיון",
        "לא, אין לי ניסיון"
      ];

      if (!valid.includes(answer)) {
        return "נא לבחור אחת האפשרויות בלבד 🥊";
      }

      return null;
    }

    if (currentStep === 3) {
      const valid = [
        "🥊 MMA",
        "🥋 הגנה עצמית",
        "💪 כושר קרבי",
        "⭐ הכול מעניין אותי",
        "⚪ לא משנה לי"
      ];

      if (!valid.includes(answer)) {
        return "נא לבחור אחת האפשרויות בלבד 🥊";
      }

      return null;
    }

    if (currentStep === 4) {
      const valid = [
        "💪 ירידה במשקל",
        "🔥 שיפור כושר",
        "🧠 ביטחון עצמי",
        "🏆 הכנה לתחרויות",
        "⭐ הכול מעניין אותי",
        "⚪ לא משנה לי"
      ];

      if (!valid.includes(answer)) {
        return "נא לבחור אחת האפשרויות בלבד 🥊";
      }

      return null;
    }

    if (currentStep === 5) {
      const phone = answer.replace(/\D/g, "");

      if (!/^0\d{9}$/.test(phone)) {
        return "נא לרשום מספר טלפון תקין 📱";
      }

      return null;
    }

    return null;
  };

  const sendMessage = (answerText = input) => {
    if (!answerText.trim()) {
      return;
    }

    const error = checkAnswer(
      answerText,
      step
    );

    if (error) {
      setMessages(prev => [
        ...prev,
        {
          from: "bot",
          text: error
        }
      ]);

      return;
    }

    const newAnswers = [
      ...answers,
      answerText
    ];

    setAnswers(newAnswers);

    setMessages(prev => [
      ...prev,
      {
        from: "user",
        text: answerText
      }
    ]);

    setInput("");

    if (
      step <
      questions.length - 1
    ) {
      setTimeout(() => {
        const nextStep = step + 1;

        setMessages(prev => [
          ...prev,
          {
            from: "bot",
            text: questions[nextStep]
          }
        ]);

        if (nextStep === 2) {
          setOptions([
            "כן, יש לי ניסיון",
            "לא, אין לי ניסיון"
          ]);
        } else if (nextStep === 3) {
          setOptions([
            "🥊 MMA",
            "🥋 הגנה עצמית",
            "💪 כושר קרבי",
            "⭐ הכול מעניין אותי",
            "⚪ לא משנה לי"
          ]);
        } else if (nextStep === 4) {
          setOptions([
            "💪 ירידה במשקל",
            "🔥 שיפור כושר",
            "🧠 ביטחון עצמי",
            "🏆 הכנה לתחרויות",
            "⭐ הכול מעניין אותי",
            "⚪ לא משנה לי"
          ]);
        } else {
          setOptions([]);
        }

        setStep(nextStep);
      }, 500);

      return;
    }

    setStep(questions.length);

    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        {
          from: "bot",
          text:
            "🎉 מעולה!\nלחץ על הכפתור לשליחה לוואטסאפ"
        }
      ]);

      setFinished(true);
    }, 500);
  };

  const sendWhatsapp = async () => {
    const whatsappText = `
לקוח חדש מהאתר MMA אוחנה

שם:
${answers[0] || ""}

גיל:
${answers[1] || ""}

ניסיון קודם:
${answers[2] || ""}

סוג אימון:
${answers[3] || ""}

מטרה:
${answers[4] || ""}

טלפון:
${answers[5] || ""}
`;

    const whatsappUrl =
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        whatsappText
      )}`;

    /*
      פתיחת WhatsApp מתבצעת כתוצאה ישירה
      מהלחיצה על הכפתור.
    */
    const whatsappWindow =
      window.open(
        whatsappUrl,
        "_blank"
      );

    /*
      הרישום ל-Excel מתבצע רק כאן,
      כלומר רק בלחיצה על
      "שליחה לוואטסאפ".
    */
    try {
      const response = await fetch(
        WHATSAPP_LOG_API,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            type: "WhatsApp",
            phone: BUSINESS_PHONE,
            page: window.location.href,
            timestamp:
              new Date().toISOString()
          }),
          keepalive: true
        }
      );

      if (!response.ok) {
        throw new Error(
          `HTTP ${response.status}`
        );
      }

      const data =
        await response.json();

      console.log(
        "לחיצת WhatsApp נרשמה בהצלחה:",
        data
      );
    } catch (error) {
      console.error(
        "שגיאה ברישום WhatsApp:",
        error
      );
    }

    if (!whatsappWindow) {
      window.location.href =
        whatsappUrl;
    }

    setFinished(false);

    setMessages([
      {
        from: "bot",
        text:
          "✅ תודה רבה!\nקיבלנו את הפרטים.\n🥊 נחזור אליך בהקדם."
      }
    ]);

    setTimeout(() => {
      setOpen(false);
    }, 14000);

    setTimeout(() => {
      setStep(0);
      setAnswers([]);
      setInput("");
      setOptions([]);
      setFinished(false);

      setMessages([
        {
          from: "bot",
          text: questions[0]
        }
      ]);
    }, 15000);
  };

  return (
    <>
      {!open && (
        <button
          className="chat-button"
          onClick={() => setOpen(true)}
        >
          <FaComments />
        </button>
      )}

      <div
        className={`chat-box ${
          open ? "open" : ""
        }`}
        dir="rtl"
      >
        <div className="chat-header">
          <span>
            MMA אוחנה 🥊
          </span>

          <FaTimes
            onClick={() =>
              setOpen(false)
            }
          />
        </div>

        <div className="chat-body">
          {messages.map((m, i) => (
            <div
              key={i}
              className={
                m.from === "bot"
                  ? "bot"
                  : "user"
              }
              dir="rtl"
              style={{
                direction: "rtl",
                textAlign: "right",
                unicodeBidi: "plaintext"
              }}
            >
              {m.text}
            </div>
          ))}

          <div ref={bottomRef}></div>

          {options.length > 0 && (
            <div className="chat-options">
              {options.map(
                (option, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      sendMessage(
                        option
                      );
                      setOptions([]);
                    }}
                  >
                    {option}
                  </button>
                )
              )}
            </div>
          )}
        </div>

        {finished && (
          <button
            className="sendWA"
            onClick={sendWhatsapp}
          >
            שליחה לוואטסאפ 🟢
          </button>
        )}

        {!finished &&
          !options[step] && (
            <div className="chat-input">
              <input
                dir="rtl"
                style={{
                  textAlign: "right"
                }}
                value={input}
                onChange={e =>
                  setInput(
                    e.target.value
                  )
                }
                onKeyDown={e => {
                  if (
                    e.key === "Enter"
                  ) {
                    sendMessage();
                  }
                }}
                placeholder="כתוב תשובה..."
              />

              <button
                onClick={() =>
                  sendMessage()
                }
              >
                <FaPaperPlane />
              </button>
            </div>
          )}
      </div>
    </>
  );
}
